import React, { Component } from "react"
import { connect } from "react-redux"
import MagicLinkLockError from "../../../images/magic-link/magic-link-lock-error.svg"
import { Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { routeChange, routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import GoBackLogo from "../../../images/rewards/back.svg"
import ReactSVG from "react-svg"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import { EBAY } from "../../../v1/constants/affiliations"
import InfoIcon from "../../../images//Icon.png"

class RenderOptions extends Component {
  constructor(props) {
    super(props)
    const { options } = this.props
    this.state = {
      activeOption: options && options.length === 1 ? options[0].name : options[0].name
    }
  }

  componentDidMount() {
    const { options, onOptionChange } = this.props

    if (options && options.length > 0) {
      const firstOption = options[0].name
      onOptionChange(firstOption)
    }
  }

  handleOptionChange = async (option) => {
    this.props.onOptionChange(option)
    this.setState({ activeOption: option })
  }

  render() {
    const { options, buttonsContainer, onSubmit, t, isOtp } = this.props
    const { activeOption } = this.state

    return (
      <div className="magic-link-options-container">
        {getSubdomain() === EBAY ? (
          <div className="ebay-info-message">
            <Image src={InfoIcon} className="ebay-info-icon" />
            <span>{t("otp:EbayInfoMessageAtOTP")}</span>
          </div>
        ) : (
          <Image src={MagicLinkLockError} className="magic-link-lock-image" />
        )}
        <div className="magic-link-description">
          <div className="magic-link-header-text">
            {isOtp
              ? getSubdomain() === EBAY
                ? t("otp:requestOneTimePasscodeEbayEmail")
                : t("otp:requestOtp")
              : t("magicLinkHeaderText")}
          </div>
          {!isOtp && <div className="magic-link-meta-text">{t("magicLinkMetaText")}</div>}
        </div>
        <RenderMagicLinkOptions
          key="magic-link-option"
          activeOption={activeOption}
          onChange={this.handleOptionChange}
          options={options}
        />
        {buttonsContainer(onSubmit)}
      </div>
    )
  }
}

const RenderMagicLinkOptions = (props) => {
  const { options, activeOption, onChange } = props
  return (
    <div className="options-render-grid">
      {options &&
        options.map((option) => {
          return (
            <label
              key={option.name}
              className={`option-card ${option.name === activeOption ? "selected" : ""}`}
              onClick={() => option.name !== activeOption && onChange(option.name)}
            >
              <div className="options-item">
                <span className="options-details">
                  <Image src={option.icon} className="option-icon" />
                  <span className="option-label">{option.label}</span>
                </span>
                <input
                  name="name"
                  className="option-radio"
                  type="radio"
                  checked={option.name === activeOption}
                  readOnly
                />
              </div>
              {activeOption === option.name && option.component()}
            </label>
          )
        })}
    </div>
  )
}

function mapStateToProps(state) {
  let user = state.user || {}

  return {
    user,
    isLoggedIn: !!user.authentication_token
  }
}

export default withRouter(connect(mapStateToProps, {})(withTranslation("signIn")(RenderOptions)))
